import store from '@/store';

const ClientOrderCreate = () => import(/* webpackChunkName: "orders" */ './ClientOrderCreate.vue');
const SupplierOrderCreate = () =>
  import(/* webpackChunkName: "orders" */ './SupplierOrderCreate.vue');
const CLIENT = 'client';
const SUPPLIER = 'supplier';

export default {
  name: 'AccountOrderCreate',
  functional: true,
  props: {
    accountId: [String],
  },
  render(h, ctx) {
    const { type = CLIENT } = store.getters['ui/accounts/account'] || {};

    if (type === SUPPLIER) return h(SupplierOrderCreate, ctx);
    return h(ClientOrderCreate, ctx);
  },
};
